<template>
  <div class="about about-pages">
    <div class="title-container"><h2 class="container">食を知る</h2></div>
    <div class="container">
      <photo-and-text
        title="勝浦熟成《貯蔵》みかん"
        text="徳島県内でかつうら町と言えば、ほとんどの方がイメージされるのが、<br>
特産品の温州みかん。<br>
その中でも、11月～翌年1月に収穫した後、2～4ヵ月の間、<br>
専用の「貯蔵庫」で熟成させたのちに出荷する熟成《貯蔵》みかんこそ、<br>
かつうら町らしい逸品と言えるでしょう。<br>
熟成させることで、酸味が落ち甘さが際立つ特別なみかんは、<br>
例年2月下旬より出荷がはじまり、皆さまの口福のもととなっています。"
        imgSrc="/static/photos/mikan.jpg"
        imgAlt="昔の勝浦町"
        imgClass="contain"
        isRightPhoto
      ></photo-and-text>
      <photo-and-text
        title="立川太郎あゆ"
        text="河川の多い徳島県では、いたるところで鮎などの川魚釣りが楽しめます。
勝浦川は他の河川に比べ、流れが急峻なこともあって鮎のエサとなる苔の生育が悪く、
力強い鮎のみが生育できると言われています。
徳島藩の御用林のあった立川地区に藩主が滞在したとき、食膳にのぼった勝浦川の鮎が美味なことに感動し「立川太郎」と名づけられました。
そんな殿様お気に入りの逸品、ぜひともご賞味くださいませ。"
        imgSrc="/static/photos/ayu.jpg"
        imgAlt="昔の勝浦町"
      ></photo-and-text>
      <photo-and-text
        title="ほたようかん"
        text="ようかんと名前がついてはいるけれど、他に類例を見ない形状の伝統菓子。
黒糖を100%使用し、山芋を併せてふっくらと蒸し上げたほたようかんは、
確かな甘みと、独特のもちもち食感が人気だ。
昔は、農作業の合間に食べられるお茶菓子としてふるまわれたといい、
老若男女に愛される地域の味を、今に伝えてくれています。"
        imgSrc="/static/photos/hota_yokan.jpg"
        imgAlt="昔の勝浦町"
        isRightPhoto
      ></photo-and-text>
      <photo-and-text
        title="野蒜（のびる）"
        text="ネギやニラの仲間で、ツンとした香りとヌルっとした食感の多年草。全国の田畑の土手などに自生していますが、かつうら町ではこれを栽培し、出荷している全国でもまれな地域です。そのほとんどは関西の料亭で旬の味として親しまれています。"
        imgSrc="/static/photos/nobiru.jpg"
        imgAlt="昔の勝浦町"
      ></photo-and-text>
      <photo-and-text
        title="地酒"
        text="かつうら町にも酒蔵があり、その銘柄を「桂華」といいます。自社販売の町内消費ぶんしか醸さない蔵なので、町外に出回ることがありません。名前の通りに優しい飲み口ですが、のど越しにキリっとしまった力強さが立ち上がる芯の強い清酒です。"
        imgSrc="/static/photos/keika_sake.jpg"
        imgAlt="昔の勝浦町"
        isRightPhoto
        imgClass="contain"
      ></photo-and-text>
      <photo-and-text
        title="ジビエ"
        text="野生鳥獣の多い中山間地であるかつうら町では、古くから猟師たちが猪や鹿を食肉として食べる習慣がありました。今でもそれは変わりなく、町内ではそうしたジビエを楽しめるお店もございます。"
        imgSrc="/static/photos/ino_shika.jpg"
        imgAlt="昔の勝浦町"
      ></photo-and-text>
    </div>
  </div>
</template>

<script>
import PhotoAndText from '../../components/PhotoAndText';

export default {
  name: 'history',
  components: {
    PhotoAndText,
  },
  computed: {
  }
}

</script>

<style scoped>

h2 {
  text-align: left;
  color: white;
}

.sub_content_img {
  width: 90%;
  object-fit: cover;
  max-height: 400px;
}

</style>
